import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Tooltip from "./../utils/Tooltip";

// State
import { removeCartProduct, clearDeleteMsg } from "../../store/actions/cart";
import { revertCheckoutAfterCartChanged } from "../../store/actions/checkout";

// Util
import { removeFromCart as removeFromCartGA } from "../../utils/google-analytics";

class DeleteCell extends Component {
	componentWillMount() {
		this.props.clearDeleteMsg();
	}

	removeCartProduct() {
		this.props
			.removeCartProduct(this.props.product.id)
			.then(() => this.props.revertCheckoutAfterCartChanged());
		removeFromCartGA(this.props.product);
	}

	render() {
		let error = null;
		if (this.props.deleteError && this.props.deletedId === this.props.product.id) {
			error = (
				<Tooltip
					parent={this.tooltipParentName}
					type={"dialog--error"}
					messageObjects={[this.props.deleteError]}
					closeAction={this.props.clearDeleteMsg}
				/>
			);
		}

		return (
			<div className="">
				{error}
				<div
					className="icon-cross delete-btn"
					ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
					onClick={() => this.removeCartProduct()}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		deleteSuccess: state.cart.deleteSuccess,
		deleteError: state.cart.deleteError,
		deletedId: state.cart.deletedId,
		deleteInProcess: state.cart.deleteInProcess
	};
};

export default connect(
	mapStateToProps,
	{ removeCartProduct, revertCheckoutAfterCartChanged, clearDeleteMsg }
)(DeleteCell);



// WEBPACK FOOTER //
// ./src/components/cart/DeleteCell.js